export const PAGE_DATA_ACTIONS = {
  SET_STATE: "pageData/setState",
  GET_PAGE_DATA: "pageData/getPageData",
  GET_PAGE_DATA_BY_ID: "pageData/getPageDataById",
  CREATE_PAGE_DATA: "pageData/createPageData",
  UPDATE_PAGE_DATA: "pageData/updatePageData",
};
